import { SkyText } from "@skypointcloud/skypoint-ui";
import type { OverviewRuns } from "@shared/types/overview";
import { runStatusListParam } from "@shared/types/runs";
import { ROUTES } from "@/lib/routes";
import { OverviewLink } from "./OverviewCard";

/**
 * Running now (round 10, O5): how many runs are in flight at this moment, "N running · M queued",
 * with no time window (the Runs card's counts are the last 24 hours). "Running now" opens the Runs
 * list filtered to both statuses (round 10 wave 2, `?status=queued,running`); each number opens it
 * filtered to its own. It is part of the overview read, so it refreshes with it. An older server
 * sends no `active`, and then there is no tile.
 */
export function RunningNowTile({ active }: { active: NonNullable<OverviewRuns["active"]> }) {
  const link = (status: "running" | "queued", count: number) => (
    <OverviewLink
      to={`${ROUTES.runs}?status=${status}`}
      testId={`overview-running-now-${status}`}
      ariaLabel={`${count.toLocaleString()} ${status}. Open the Runs list filtered to ${status}.`}
    >
      {`${count.toLocaleString()} ${status}`}
    </OverviewLink>
  );
  return (
    <div
      className="flex flex-wrap items-baseline gap-x-2 rounded-md bg-muted px-3 py-2"
      data-testid="overview-running-now"
    >
      <SkyText size={200} color="muted">
        <OverviewLink
          to={`${ROUTES.runs}?status=${runStatusListParam(["running", "queued"])}`}
          testId="overview-running-now-all"
          ariaLabel="Running now. Open the Runs list filtered to running and queued."
          tone="neutral"
        >
          Running now
        </OverviewLink>
      </SkyText>
      <SkyText size={300} font="numeric">
        {link("running", active.running)}
        {" · "}
        {link("queued", active.queued)}
      </SkyText>
    </div>
  );
}
